import styled, { CSSObject } from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const mobileStyles: CSSObject = {
  marginTop: 20
};

const desktopStyles: CSSObject = {
  marginTop: 27
};

const SubContentWrapper = styled.div({
  [media('xs')]: mobileStyles,
  [media('lg')]: desktopStyles,
  marginBottom: 17
});

export default SubContentWrapper;
